import { createContext, useContext } from 'react'

const SignupFormContext = createContext()

export const SignupFormProvider = SignupFormContext.Provider
export const SignupFormConsumer = SignupFormContext.Consumer

export const useSignupFormContext = () => useContext(SignupFormContext)
